import React from "react";
import Select, { components, useStateManager } from "react-select";
import { ImageUrlPrefix } from "../../../../labels";
import { customStyles } from "../../../../pages/customStyles";
import DatePickerSample from "../../DatePicker";
import AddJobInfo from "./AddJobInfo";

const FacultyProfileStep4 = ({
  staff_type,
  user_type,
  list,
  listErrors,
  handleChange,
  txtAdWorkingexp,
  txtAdTeachingexp,
  txtWfile,
  designation,
  txtAdDes,
  txtAdDjoin,
  handleChangeCuDate,
  locations,
  txtfacLoc,
  txtAdVoicepp,
  addJob,
  handleChangeAjob,
  handleChangeAjobs,
  department,
  DeleteAddJobinfo,
  handleAddJobinfo,
  errDep,
}) => {
  return (
    <>
      {/* Previous Experience */}
      <fieldset className="mt-3">
        <legend className="w-auto">Previous Experience</legend>
        <form className="row g-3">
          {/* Previous Experience Question */}
          <div className="col-md-12">
            <label htmlFor="prevTeachexp" className="form-label confirm_value">
              Do you have any previous working or teaching experience?
            </label>
            <div className="radioGroup d-flex flex-row">
              <div className="formCheck d-flex gap-4">
                <div>
                  <input
                    className="checkbox_radio"
                    type="radio"
                    name="prevTeachexp"
                    id="prevTeachexp1"
                    onChange={handleChange}
                    checked={list.prevTeachexp === "Yes"}
                    value="Yes"
                  />
                  <label
                    className="checkbox-label ms-1"
                    htmlFor="prevTeachexp1"
                  >
                    Yes
                  </label>
                </div>
                <div>
                  <input
                    className="checkbox_radio"
                    type="radio"
                    name="prevTeachexp"
                    id="prevTeachexp2"
                    onChange={handleChange}
                    checked={list.prevTeachexp === "NO"}
                    value="NO"
                  />
                  <label
                    className="checkbox-label ms-1"
                    htmlFor="prevTeachexp2"
                  >
                    No
                  </label>
                </div>
              </div>
            </div>
            {listErrors?.prevTeachexp && (
              <p className="error_message">{listErrors.prevTeachexp}</p>
            )}
          </div>

          {/* If user has experience, show additional fields */}
          {list.prevTeachexp === "Yes" && (
            <>
              {/* Working and Teaching Experience Textareas */}
              <div className="col-md-6">
                <label
                  htmlFor="workingexp"
                  className="form-label confirm_value"
                >
                  Working Experience
                </label>
                <textarea
                  className="Inputs w-100 rounded-2 input-font-size-sm"
                  ref={txtAdWorkingexp}
                  name="workingexp"
                  id="workingexp"
                  defaultValue={list.workingexp}
                  onChange={handleChange}
                  placeholder="Working Experience"
                />
                {listErrors.workingexp && (
                  <small className="error_message">
                    {listErrors.workingexp}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="teachexp" className="form-label confirm_value">
                  Teaching Experience
                </label>
                <textarea
                  className="Inputs w-100 rounded-2 input-font-size-sm"
                  ref={txtAdTeachingexp}
                  name="teachexp"
                  id="teachexp"
                  defaultValue={list.teachexp}
                  onChange={handleChange}
                  placeholder="Teaching Experience"
                />
                {listErrors.teachexp && (
                  <small className="error_message">{listErrors.teachexp}</small>
                )}
              </div>

              {/* Upload Fields */}
              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="working_ex_file"
                    className="form-label confirm_value"
                  >
                    Working Experience File (PDF/Image)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {list.working_ex_file && (
                      <a
                        href={`${ImageUrlPrefix}/${list.working_ex_file}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <input
                    className="InputsSelectFile m-0"
                    ref={txtWfile}
                    type="file"
                    name="working_ex_file"
                    id="working_ex_file"
                    onChange={handleChange}
                  />

                  {list.original_workexp && (
                    <div className="mt-1">
                      <span>{list.original_workexp}</span>
                    </div>
                  )}
                  {listErrors.working_ex_file && (
                    <span className="error_message">
                      {listErrors.working_ex_file || "-"}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-sm-12">
                <div className="forms">
                  <label
                    htmlFor="Teaching_ex_file"
                    className="form-label confirm_value"
                  >
                    Teaching Experience File (PDF/Image)
                    <span className="form-label confirm_label">
                      {" "}
                      (optional)
                    </span>
                    {list.Teaching_ex_file && (
                      <a
                        href={`${ImageUrlPrefix}/${list.Teaching_ex_file}`}
                        target="_blank"
                        download
                      >
                        <span className="material-icons align-middle download_icon">
                          file_download
                        </span>
                      </a>
                    )}
                  </label>

                  <input
                    className="InputsSelectFile m-0"
                    type="file"
                    name="Teaching_ex_file"
                    id="Teaching_ex_file"
                    onChange={handleChange}
                  />

                  {list.original_teachexp && (
                    <div className="mt-1">
                      <span>{list.original_teachexp}</span>
                    </div>
                  )}
                  {listErrors.Teaching_ex_file && (
                    <span className="error_message">
                      {listErrors.Teaching_ex_file || "-"}
                    </span>
                  )}
                </div>
              </div>
            </>
          )}
        </form>
      </fieldset>

      {/* Job Info */}

      <fieldset className="mt-3">
        <legend className="w-auto">Current Job Info</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="teachType" className="form-label confirm_value">
              Job Type
            </label>
            <div className="radioGroup d-flex flex-row">
              <div className="formCheck d-flex gap-4">
                {/* Teaching Option */}
                <div>
                  <input
                    className="checkbox_radio"
                    type="radio"
                    name="teachType"
                    id="Teaching"
                    value="1"
                    checked={list.teachType === "1"}
                    onChange={handleChange}
                    disabled={user_type !== 1}
                  />
                  <label className="checkbox-label ms-1" htmlFor="Teaching">
                    Teaching
                  </label>
                </div>

                {/* Non-Teaching Option */}
                <div>
                  <input
                    className="checkbox_radio"
                    type="radio"
                    name="teachType"
                    id="NonTeaching"
                    value="0"
                    checked={list.teachType === "0"}
                    onChange={handleChange}
                    disabled={user_type !== 1 || list.staff_type == 0}
                  />
                  <label className="checkbox-label ms-1" htmlFor="NonTeaching">
                    Non Teaching
                  </label>
                </div>
              </div>
            </div>

            {listErrors?.teachType && (
              <p className="error_message">{listErrors.teachType}</p>
            )}
          </div>
          {staff_type !== 3 && (
            <>
              {/* Designation */}
              <div className="col-md-6">
                <label
                  for="designation"
                  title={`sdsd${user_type}`}
                  className="form-label confirm_value"
                >
                  Designation
                </label>
                <Select
                  ref={txtAdDes}
                  isDisabled={user_type !== 1}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "designation_id",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  className={`shadow-none input-font-size margin-left-zero mt-2`}
                  value={
                    list.designation_id
                      ? {
                          value: list.designation_id,
                          label: list.designation,
                        }
                      : null
                  }
                  options={designation}
                  isSearchable={true}
                  placeholder="Select an designation"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                />

                {listErrors.designation && (
                  <small className="error_message">
                    {listErrors.designation}
                  </small>
                )}
              </div>

              {/* Date of Joining */}
              <div className="col-md-6">
                <label
                  htmlFor="year_of_passing"
                  className="form-label confirm_value"
                >
                  Date of Joining
                </label>
                <DatePickerSample
                  disabledProperty={user_type !== 1 ? true : false}
                  txtAdMDob={txtAdDjoin}
                  name={"DJoin"}
                  handleChange={handleChangeCuDate}
                  fieldInput={list.DJoin}
                />
                {listErrors.DJoin && (
                  <small className="error_message">{listErrors.DJoin}</small>
                )}
              </div>

              {/* Branch Location */}
              <div className="col-md-6">
                <label
                  for="designation"
                  title={`sdsd${user_type}`}
                  className="form-label confirm_value"
                >
                  Branch Location
                </label>
                <Select
                  ref={txtfacLoc}
                  id="location"
                  name="location"
                  isDisabled={user_type !== 1}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "location_id",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  className={`shadow-none input-font-size margin-left-zero mt-2`}
                  value={
                    list.location_id
                      ? {
                          value: list.location_id,
                          label: list.location_name,
                        }
                      : null
                  }
                  options={locations}
                  isSearchable={true}
                  placeholder="Select an location"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                />

                {listErrors.location && (
                  <small className="error_message">{listErrors.location}</small>
                )}
              </div>
            </>
          )}
        </form>
      </fieldset>

      {staff_type === 3 && (
        <>
          {addJob.map((item, index) => (
            <AddJobInfo
              key={index.toString()}
              record={item}
              index={index}
              jobError={errDep[index] || {}}
              length={addJob.length}
              handleChangeAjob={handleChangeAjob}
              handleChangeAjobs={handleChangeAjobs}
              department={department}
              designation={item?.designationOptions}
              DeleteAddJobinfo={DeleteAddJobinfo}
              handleAddJobinfo={handleAddJobinfo}
            />
          ))}
        </>
      )}

      {/* Voice Your Opinion*/}
      <fieldset className="mt-3">
        <legend className="w-auto">Voice Your Opinion</legend>
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="VoiceOpinion" className="form-label confirm_value">
              Insights and Proposals
            </label>
            <textarea
              className="Inputs w-100 rounded-2 input-font-size-sm"
              ref={txtAdVoicepp}
              name="VoiceOpinion"
              id="VoiceOpinion"
              onChange={handleChange}
              defaultValue={list.VoiceOpinion}
              placeholder="Insights and Proposals"
            ></textarea>
            {listErrors.VoiceOpinion && (
              <small className="error_message">{listErrors.VoiceOpinion}</small>
            )}
          </div>
        </form>
      </fieldset>
    </>
  );
};

export default FacultyProfileStep4;
